import { SerializedError } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { routes } from "@/api/services/routes";
import { logError } from "@/utilities/api";
import { Alert, ResolvedAlert } from "@/utilities/types/alert";

import { AlertService } from "../interfaces";


const client = applyCaseMiddleware(axios.create({ withCredentials: true }));

export const alertService: AlertService = {
    async getAlerts(): Promise<Alert[]> {
        const route = routes.getAlerts();

        try {
            const response = await client.get(route);

            if (response.status == 200) {
                return response.data.data;
            } else {
                const error: SerializedError = {
                    name: "statusCode",
                    message: "Error" + response.data.status + ": " + response.data.statusMessage,
                };

                throw error;
            }
        } catch (error: any) {
            logError(route, error);

            throw error;
        }
    },

    async postResolveAlert(resolvedAlert: ResolvedAlert): Promise<void | Error> {
        await client.post(routes.postResolveAlert(resolvedAlert.alertId), resolvedAlert);
    },

    async getAlert(alertId: string): Promise<Alert> {
        const route = routes.getAlert(alertId);

        try {
            const response = await client.get(route);

            if (response.status == 200) {
                return response.data.data;
            } else {
                const error: SerializedError = {
                    name: "statusCode",
                    message: "Error" + response.data.status + ": " + response.data.statusMessage,
                };

                throw error;
            }
        } catch (error: any) {
            logError(route, error);

            throw error;
        }
    },
};
